// npm install @azure/msal-browser @azure/msal-react
import React from "react";

const Reports = () => {
  return (
    <div style={{ height: "100vh" }}>
      <iframe
        title="Power BI Report"
        // Do not share or upload the link below as it contains sensitive information. It is intended for Tamu access only.
        // src="https://app.powerbi.com/reportEmbed?reportId=c1a9aefa-9da2-4629-8560-a1201349588c&autoAuth=true&ctid=68f381e3-46da-47b9-ba57-6f322b8f0da1"
        src="https://app.powerbi.com/reportEmbed?reportId=fba04bd7-36a9-44bf-8482-d2319d2d28c2&autoAuth=true&ctid=68f381e3-46da-47b9-ba57-6f322b8f0da1"
        width="100%"
        height="100%"
        allowFullScreen
      />
    </div>
  );
};

export default Reports;